import EmbedSkeleton from '@cohort/components-xps/components/apps/EmbedSkeleton';
import type {CohortFormEmailTriggerStruct} from '@cohort/shared/apps/cohort-form/triggers/email';
import {CohortFormEmailTriggerIntegrationSpec} from '@cohort/shared/apps/cohort-form/triggers/email';
import TriggerFormWrapper, {
  useSyncUserAttributesToForm,
} from '@cohort/wallet/apps/cohort-form/triggerIntegrations/TriggerFormWrapper';
import type {TriggerIntegrationUsageComponentProps} from '@cohort/wallet/apps/TriggerIntegration';
import {Input} from '@cohort/wallet/components/forms/Input';
import {zodResolver} from '@hookform/resolvers/zod';
import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import type {z} from 'zod';

type CohortFormEmail = z.infer<
  (typeof CohortFormEmailTriggerIntegrationSpec)['verificationAttemptInputSchema']
>;

const CohortFormEmailUsageComponent: React.FC<
  TriggerIntegrationUsageComponentProps<CohortFormEmailTriggerStruct>
> = ({onTriggerIntegrationUsageSuccess, stepId, config}) => {
  const {t} = useTranslation('app-cohort-form', {
    keyPrefix: 'triggerIntegrations.email',
  });
  const {
    register,
    handleSubmit,
    resetField,
    formState: {errors, isValid},
  } = useForm<CohortFormEmail>({
    resolver: zodResolver(CohortFormEmailTriggerIntegrationSpec.verificationAttemptInputSchema),
  });
  const shouldDisplayLoader = useSyncUserAttributesToForm(config.userPropertyId, resetField);
  const error = errors.answer?.message;

  if (shouldDisplayLoader) {
    return <EmbedSkeleton width="100%" height={200} />;
  }

  return (
    <TriggerFormWrapper
      stepId={stepId}
      formId="email-form"
      error={error}
      isValid={isValid}
      onSubmit={handleSubmit(data => onTriggerIntegrationUsageSuccess(data))}
    >
      <Input type="email" register={register('answer')} placeholder={t('placeholderEmailInput')} />
    </TriggerFormWrapper>
  );
};

export default CohortFormEmailUsageComponent;
